import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// envs
import { environment } from '@environments/environment';

// Services
import { CookieService } from 'ngx-cookie-service';

// enums
import { PRODUCT_TYPE_ENUMERATION, COOKIE_ENUMERATION } from './../configs';

@Injectable({
  providedIn: 'root',
})
export class CreateAccountCaseService {
  constructor(private readonly cookieService: CookieService, private readonly router: Router) {}

  public execute({ userIsAlliance }: { userIsAlliance: boolean }): void {
    const getOriginCookie: string | undefined = this.cookieService.get(COOKIE_ENUMERATION.ORIGIN);
    if (getOriginCookie) {
      this.cookieService.delete(COOKIE_ENUMERATION.ORIGIN, '/', environment.domain);
    }
    if (userIsAlliance || getOriginCookie === PRODUCT_TYPE_ENUMERATION.RAPI_PLAZO) {
      this.router.navigate(['/account/emailVerification']);
    } else {
      window.location.href = `${environment.onboardingRapiflex}signUp`;
    }
  }
}
